import { httpApi } from "@/services/http.api";

export const loadImage = async (recorderId) => {
  const resp = await httpApi.get(`/supervisor/last-frame/${recorderId}`, {
    responseType: "arraybuffer",
  });
  return resp.data;
};

export const loadrecorders = async () => {
  const response = await httpApi.get(`/supervisor/recorders`);
  return response.data;
};

export const loadLastFrame = async (recorderId) => {
  const response = await httpApi.get(`/supervisor/last-frame/${recorderId}`, {
    silentError: true,
  });
  return response.data;
};

export const loadLastFrameFile = async (recorderId) => {
  const response = await httpApi.get(
    `/supervisor/last-frame-file/${recorderId}`
  );
  return response.data;
};

export const loadStatus = async () => {
  const response = await httpApi.get(`/supervisor/status`);
  return response.data;
};

export const loadImageAsBase64 = async (recorderId) => {
  try {
    const arrayBuffer = await loadImage(recorderId);
    const bytes = new Uint8Array(arrayBuffer);
    let binary = "";
    for (let b of bytes) {
      binary += String.fromCharCode(b);
    }
    return "data:image/png;base64," + btoa(binary);
  } catch (err) {
    console.error("Error cargando imagen de", recorderId, err);
    return "";
  }
};

export const loadAvailablerecorders = async () => {
  const response = await httpApi.get(`/supervisor/recorders/available`);
  return response.data;
};

export const updaterecorder = async (recorderId, nombre) => {
  const response = await httpApi.put(`/supervisor/recorder`, {
    recorderId: recorderId,
    nombre: nombre,
  });
  return response.data;
};

export const deleterecorder = async (recorderIdentifier) => {
  const response = await httpApi.delete(
    `/supervisor/recorder/${recorderIdentifier}`
  );
  return response.data;
};

export const loadHeartbeats = async () => {
  const response = await httpApi.get(`/supervisor/recorders/heartbeats`);
  return response.data;
};
